(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    'use strict';

    /* ── Quantity stepper ── */
    document.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var input = document.querySelector('.cart-item__qty-input[data-key="' + key + '"]');
        if (!input) return;
        var current = parseInt(input.value, 10) || 0;
        var next = btn.dataset.action === 'increment' ? current + 1 : Math.max(0, current - 1);
        input.value = next;
        updateCartItem(key, next);
      });
    });

    document.querySelectorAll('.cart-item__qty-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        input.value = qty;
        updateCartItem(input.dataset.key, qty);
      });
    });

    function updateCartItem(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (qty === 0) {
            var item = document.querySelector('.cart-item[data-key="' + key + '"]');
            if (item) item.remove();
            var items = document.querySelectorAll('.cart-item');
            if (items.length === 0) location.reload();
          }
          updateTotals(cart.total_price);
        })
        .catch(function () { location.reload(); });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function updateTotals(totalCents) {
      var subtotalEl = document.getElementById('cart-subtotal');
      var totalEl = document.getElementById('cart-total');
      var formatted = formatMoney(totalCents);
      if (subtotalEl) subtotalEl.textContent = formatted;
      if (totalEl) totalEl.textContent = formatted;
    }

    /* ── Zip estimator toggle ── */
    var zipToggle = document.querySelector('.cart-zip__toggle');
    var zipPanel = document.getElementById('cart-zip-form');

    if (zipToggle && zipPanel) {
      zipToggle.addEventListener('click', function () {
        var expanded = zipToggle.getAttribute('aria-expanded') === 'true';
        zipToggle.setAttribute('aria-expanded', String(!expanded));
        zipPanel.hidden = expanded;
      });
    }

    /* ── Zip estimator fetch ── */
    var zipSubmit = document.getElementById('cart-zip-submit');
    var zipInput = document.getElementById('cart-zip-input');
    var zipResult = document.getElementById('cart-zip-result');

    if (zipSubmit && zipInput && zipResult) {
      zipSubmit.addEventListener('click', function () {
        var zip = zipInput.value.trim();
        if (!zip || zip.length < 5) {
          showZipResult('Please enter a valid ZIP code.', 'error');
          return;
        }

        zipSubmit.disabled = true;
        zipSubmit.textContent = '...';

        var url = '/cart/shipping_rates.json?shipping_address[zip]=' +
          encodeURIComponent(zip) +
          '&shipping_address[country]=US&shipping_address[province]=';

        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var rates = data.shipping_rates;
            if (!rates || rates.length === 0) {
              showZipResult('No rates available for this ZIP.', 'error');
            } else {
              var free = rates.find(function (r) { return parseFloat(r.price) === 0; });
              if (free) {
                showZipResult('<i class="fa-solid fa-circle-check" aria-hidden="true"></i> Free shipping to ' + zip + ' — ' + free.name, 'free');
              } else {
                var lines = rates.map(function (r) {
                  return r.name + ': ' + (parseFloat(r.price) === 0 ? 'Free' : '$' + parseFloat(r.price).toFixed(2));
                });
                showZipResult(lines.join('<br>'), '');
              }
            }
          })
          .catch(function () {
            showZipResult('Unable to estimate shipping. Please try again.', 'error');
          })
          .finally(function () {
            zipSubmit.disabled = false;
            zipSubmit.textContent = 'Check';
          });
      });
    }

    function showZipResult(html, type) {
      zipResult.innerHTML = html;
      zipResult.className = 'cart-zip__result' + (type ? ' cart-zip__result--' + type : '');
      zipResult.hidden = false;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    'use strict';

    var hamburger = document.getElementById('nav-hamburger');
    var drawer = document.getElementById('nav-drawer');
    var closeBtn = document.getElementById('nav-drawer-close');
    var overlay = document.getElementById('nav-overlay');

    function open() {
      drawer.setAttribute('data-open', '');
      overlay.setAttribute('data-open', '');
      hamburger.setAttribute('aria-expanded', 'true');
      drawer.removeAttribute('aria-hidden');
      overlay.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      drawer.removeAttribute('data-open');
      overlay.removeAttribute('data-open');
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (hamburger) hamburger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.hasAttribute('data-open')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-compat"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var table = document.querySelector('.pdp-compat__table');
    if (!table) return;
    var headers = table.querySelectorAll('th[data-compat-col]');

    function getMatchingCols(value) {
      var val = value.toLowerCase();
      var cols = [];
      headers.forEach(function (th) {
        var keyword = th.dataset.match || '';
        if (keyword && val.includes(keyword)) {
          cols.push(th.dataset.compatCol);
        }
      });
      return cols;
    }

    function highlightColumns(cols) {
      table.querySelectorAll('.pdp-ct__highlight').forEach(function (el) {
        el.classList.remove('pdp-ct__highlight');
      });
      cols.forEach(function (col) {
        table.querySelectorAll('[data-compat-col="' + col + '"]').forEach(function (el) {
          el.classList.add('pdp-ct__highlight');
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      var matched = false;
      document.querySelectorAll('.pdp__option-btn.is-selected').forEach(function (btn) {
        var cols = getMatchingCols(btn.dataset.optionValue || '');
        if (cols.length) {
          highlightColumns(cols);
          matched = true;
        }
      });
      if (!matched) highlightColumns(['2']);
    });

    window.addEventListener('pdp:option-changed', function (e) {
      var cols = getMatchingCols(e.detail.value || '');
      if (cols.length) highlightColumns(cols);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const items = document.querySelectorAll('.pdp-faq__item');

    items.forEach(function (item) {
      const btn = item.querySelector('.pdp-faq__q');
      const answer = item.querySelector('.pdp-faq__a');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        // Close all
        items.forEach(function (i) {
          const b = i.querySelector('.pdp-faq__q');
          const a = i.querySelector('.pdp-faq__a');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (a) a.hidden = true;
        });

        // Open clicked (toggle)
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-landing"]) return;
  try {
    
  (function () {
    'use strict';

    // Gallery switching
    const thumbs = document.querySelectorAll('.pdp__thumb');
    const slides = document.querySelectorAll('.pdp__slide');

    function goToSlide(idx) {
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
      });
      slides.forEach(function (s) {
        const v = s.querySelector('video');
        if (v) {
          v.pause();
          v.currentTime = 0;
        }
        s.classList.remove('is-active');
      });
      if (thumbs[idx]) thumbs[idx].classList.add('is-active');
      if (slides[idx]) {
        slides[idx].classList.add('is-active');
        const video = slides[idx].querySelector('video');
        if (video) {
          video.play().catch(function () {});
        }
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goToSlide(parseInt(thumb.dataset.slide, 10));
      });
    });

    // Option-based variant switching
    const variantInput = document.getElementById('pdp-variant-id');
    const priceEl = document.getElementById('pdp-price');
    const compareEl = document.getElementById('pdp-compare-price');
    const saveBadge = document.getElementById('pdp-save-badge');
    const btnPrice = document.getElementById('pdp-btn-price');
    const addBtn = document.getElementById('pdp-add-to-cart');
    const stickyPrice = document.getElementById('pdp-sticky-price');

    const variantsEl = document.getElementById('pdp-variants-json');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

    // Build initial selected options from the is-selected buttons
    const selectedOptions = {};
    document.querySelectorAll('.pdp__option-btn.is-selected').forEach(function (btn) {
      selectedOptions[btn.dataset.optionIndex] = btn.dataset.optionValue;
    });

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selectedOptions).every(function (pos) {
          return v['option' + pos] === selectedOptions[pos];
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = variant.price_f;
        priceEl.classList.toggle('is-sale', variant.is_sale);
      }
      if (compareEl) {
        compareEl.textContent = variant.compare_f;
        compareEl.style.display = variant.is_sale ? '' : 'none';
      }
      if (saveBadge) {
        saveBadge.textContent = 'SAVE ' + variant.savings_f;
        saveBadge.style.display = variant.is_sale ? '' : 'none';
      }
      if (btnPrice) btnPrice.textContent = variant.price_f;
      if (stickyPrice) stickyPrice.textContent = variant.price_f;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.setAttribute('aria-disabled', String(!variant.available));
      }
      if (variant.featured_media_index !== null && variant.featured_media_index !== undefined) {
        goToSlide(variant.featured_media_index);
      }
    }

    document.querySelectorAll('.pdp__option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;

        const idx = btn.dataset.optionIndex;
        const val = btn.dataset.optionValue;

        // Update selected state within this option group
        document.querySelectorAll('.pdp__option-btn[data-option-index="' + idx + '"]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        // Update the inline selected-value label
        const labelEl = document.getElementById('pdp-option-val-' + idx);
        if (labelEl) labelEl.textContent = val;

        selectedOptions[idx] = val;
        applyVariant(findVariant());
        window.dispatchEvent(new CustomEvent('pdp:option-changed', { detail: { index: idx, value: val } }));
      });
    });

    // Sticky bar visibility
    const buyBox = document.getElementById('pdp-buy');
    const stickyBar = document.getElementById('pdp-sticky');
    const stickyBtn = document.getElementById('pdp-sticky-btn');

    if (buyBox && stickyBar && 'IntersectionObserver' in window) {
      const obs = new IntersectionObserver(
        function (entries) {
          const visible = !entries[0].isIntersecting;
          stickyBar.classList.toggle('is-visible', visible);
          stickyBar.setAttribute('aria-hidden', String(!visible));
        },
        { threshold: 0 },
      );
      obs.observe(buyBox);
    }

    // Sticky add-to-cart triggers the main form submit
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        const form = document.getElementById('pdp-form');
        if (form) form.querySelector('[type="submit"]').click();
      });
    }

    // Lightbox
    const mediaEl = document.getElementById('pdp-media-json');
    const mediaList = mediaEl ? JSON.parse(mediaEl.textContent) : [];
    let lbIndex = 0;

    const lb = document.createElement('div');
    lb.className = 'pdp-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<div class="pdp-lb__backdrop"></div>' +
      '<button class="pdp-lb__close" aria-label="Close"><i class="fa-solid fa-xmark"></i></button>' +
      '<button class="pdp-lb__prev" aria-label="Previous"><i class="fa-solid fa-chevron-left"></i></button>' +
      '<div class="pdp-lb__wrap"></div>' +
      '<button class="pdp-lb__next" aria-label="Next"><i class="fa-solid fa-chevron-right"></i></button>';
    document.body.appendChild(lb);

    const lbWrap = lb.querySelector('.pdp-lb__wrap');
    const lbPrevBtn = lb.querySelector('.pdp-lb__prev');
    const lbNextBtn = lb.querySelector('.pdp-lb__next');

    function lbRender(idx) {
      lbIndex = ((idx % mediaList.length) + mediaList.length) % mediaList.length;
      const item = mediaList[lbIndex];
      if (!item) return;
      const oldVid = lbWrap.querySelector('video');
      if (oldVid) {
        oldVid.pause();
      }
      lbWrap.innerHTML = '';
      if (item.type === 'video') {
        const vid = document.createElement('video');
        vid.className = 'pdp-lb__video';
        vid.controls = true;
        vid.setAttribute('playsinline', '');
        if (item.poster) vid.poster = item.poster;
        (item.sources || []).forEach(function (s) {
          const src = document.createElement('source');
          src.src = s.url;
          src.type = s.mime;
          vid.appendChild(src);
        });
        lbWrap.appendChild(vid);
        vid.play().catch(function () {});
      } else {
        const img = document.createElement('img');
        img.className = 'pdp-lb__img';
        img.src = item.src;
        img.alt = item.alt || '';
        lbWrap.appendChild(img);
      }
      lbPrevBtn.style.display = mediaList.length <= 1 ? 'none' : '';
      lbNextBtn.style.display = mediaList.length <= 1 ? 'none' : '';
    }

    function lbOpen(idx) {
      lbRender(idx);
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function lbClose() {
      const vid = lbWrap.querySelector('video');
      if (vid) {
        vid.pause();
      }
      lbWrap.innerHTML = '';
      lb.hidden = true;
      document.body.style.overflow = '';
    }

    lb.querySelector('.pdp-lb__close').addEventListener('click', lbClose);
    lb.querySelector('.pdp-lb__backdrop').addEventListener('click', lbClose);
    lbPrevBtn.addEventListener('click', function () {
      lbRender(lbIndex - 1);
    });
    lbNextBtn.addEventListener('click', function () {
      lbRender(lbIndex + 1);
    });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbRender(lbIndex - 1);
      if (e.key === 'ArrowRight') lbRender(lbIndex + 1);
    });

    const galleryMain = document.querySelector('.pdp__gallery-main');
    if (galleryMain && mediaList.length) {
      galleryMain.addEventListener('click', function (e) {
        if (e.target.closest('video')) return;
        const activeIdx = Array.from(slides).findIndex(function (s) {
          return s.classList.contains('is-active');
        });
        lbOpen(activeIdx >= 0 ? activeIdx : 0);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var mainImg = document.getElementById('product-main-img');
    if (!mainImg) return;

    var thumbs = document.querySelectorAll('#product-thumbs .product__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
        mainImg.src = this.dataset.src;
        mainImg.alt = this.dataset.alt;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-banner"]) return;
  try {
    
  (function () {
    var banner = document.getElementById('sale-banner');
    if (!banner) return;

    var sectionId = banner.dataset.sectionId;
    var sessionKey = 'sale-banner-dismissed-' + sectionId;

    if (sessionStorage.getItem(sessionKey)) {
      banner.hidden = true;
      return;
    }

    var closeBtn = banner.querySelector('.sale-banner__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        banner.hidden = true;
        sessionStorage.setItem(sessionKey, '1');
      });
    }

    var codeBtn = banner.querySelector('.sale-banner__code-btn');
    if (codeBtn) {
      codeBtn.addEventListener('click', function () {
        var code = codeBtn.dataset.code;
        if (!code) return;

        function flashCopied() {
          codeBtn.classList.add('is-copied');
          setTimeout(function () {
            codeBtn.classList.remove('is-copied');
          }, 2200);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard
            .writeText(code)
            .then(flashCopied)
            .catch(function () {
              fallbackCopy(code);
              flashCopied();
            });
        } else {
          fallbackCopy(code);
          flashCopied();
        }
      });
    }

    function fallbackCopy(text) {
      var el = document.createElement('textarea');
      el.value = text;
      el.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }

    var countdown = banner.querySelector('.sale-banner__countdown');
    if (countdown) {
      var endTime = new Date(countdown.dataset.countdownEnd).getTime();
      if (isNaN(endTime)) return;

      // Hide the whole banner immediately if the sale has already ended
      if (Date.now() >= endTime) {
        banner.hidden = true;
        return;
      }

      var daysEl = countdown.querySelector('[data-unit="days"]');
      var hoursEl = countdown.querySelector('[data-unit="hours"]');
      var minutesEl = countdown.querySelector('[data-unit="minutes"]');
      var secondsEl = countdown.querySelector('[data-unit="seconds"]');

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        var diff = endTime - Date.now();
        if (diff <= 0) {
          banner.hidden = true;
          return;
        }
        var total = Math.floor(diff / 1000);
        var d = Math.floor(total / 86400);
        var h = Math.floor((total % 86400) / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;
        if (daysEl) daysEl.textContent = pad(d);
        if (hoursEl) hoursEl.textContent = pad(h);
        if (minutesEl) minutesEl.textContent = pad(m);
        if (secondsEl) secondsEl.textContent = pad(s);
        setTimeout(tick, 1000);
      }

      tick();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
